var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"ml-auto",attrs:{"disabled":!_vm.id,"color":"primary","small":"","outlined":""},on:{"click":_vm.suppliedQty}},[_vm._v(" "+_vm._s(_vm.$t("common.suppliedQuantities"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }